import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Router } from '@angular/router';
import { CustomButtonComponent } from "../../../../shared/components/custom-button/custom-button.component";
import { CommonModule } from '@angular/common';
import { CustomDateInputComponent } from '../../../../shared/components/custom-date-input/custom-date-input.component';
import { MembershipSalesAgentGet, SalesAgentUsersGet, SubscriptionSalesAgentGet } from '../../../../core/interfaces/sales-agents-interfaces';
import { HttpErrorResponse } from '@angular/common/http';
import { SalesAgentsService } from '../../../../core/api/sales-agents.service';
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { ToastComponent } from "../../../../shared/components/toast/toast.component";
import { IsoToFormattedDatePipe } from "../../../../core/pipes/iso-to-formatted-date.pipe";
import { AdminNavigationComponent } from "../../components/admin-navigation/admin-navigation.component";
import { AdminTopbarComponent } from "../../components/admin-topbar/admin-topbar.component";
import { SubscriptionStatus } from '../../../../core/interfaces/payment-interfaces';

@Component({
  selector: 'app-admin-sales-agents-data-page',
  standalone: true,
  imports: [TranslocoPipe, CustomButtonComponent, CommonModule, CustomDateInputComponent, ToastComponent, IsoToFormattedDatePipe, AdminNavigationComponent, AdminTopbarComponent],
  templateUrl: './admin-sales-agents-data-page.component.html',
  styleUrl: './admin-sales-agents-data-page.component.css'
})
export class AdminSalesAgentsDataPageComponent implements OnInit {
  constructor(private router: Router, private apiError: ApiErrorService, private salesAgentsService: SalesAgentsService) { }

  // Toast
  @ViewChild(ToastComponent) toast!: ToastComponent;

  ngOnInit(): void {
    this.toPeriodDate = new Date();
    this.fromPeriodDate = new Date();
    this.fromPeriodDate.setMonth(this.fromPeriodDate.getMonth() - 1);
    this.refreshPeriod();
  }

  // Sales agents by period
  fromPeriodInputError: string | null = null;
  fromPeriodDate: Date | undefined;

  toPeriodInputError: string | null = null;
  toPeriodDate: Date | undefined;

  fromIsoDate!: string;
  toIsoDate!: string;

  salesAgentsByPeriod: SalesAgentUsersGet[] = [];
  loadedSalesAgentsByPeriod: SalesAgentUsersGet[] = [];

  lastSalesAgentsByPeriodLoadedPageNumber: number = 0;
  loadMoreHiddenSalesAgentsByPeriod = false;

  goToDashboard() {
    this.router.navigate(["/dashboard"]);
  }

  refreshPeriod() {
    this.fromIsoDate = this.fromPeriodDate!.toISOString();
    this.toIsoDate = this.toPeriodDate!.toISOString();

    this.lastSalesAgentsByPeriodLoadedPageNumber = 0;
    this.loadedSalesAgentsByPeriod = [];
    this.salesAgentsByPeriod = [];
    this.loadSalesAgentsByPeriodNewPage();
  }

  loadSalesAgentsByPeriodNewPage() {
    this.salesAgentsService.getSalesAgentsPeriod((this.lastSalesAgentsByPeriodLoadedPageNumber + 1), 20, this.fromIsoDate, this.toIsoDate).subscribe({
      next: (response) => {
        if (response) {
          if (response.data.length === 0 || this.loadedSalesAgentsByPeriod.length + response.data.length >= response.totalCount) {
            this.loadMoreHiddenSalesAgentsByPeriod = true;
          }

          this.loadedSalesAgentsByPeriod = [...this.loadedSalesAgentsByPeriod, ...response.data];

          this.salesAgentsByPeriod = [];
          this.salesAgentsByPeriod = this.loadedSalesAgentsByPeriod;
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
        }
        this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      },
      complete: () => {
        this.lastSalesAgentsByPeriodLoadedPageNumber++;
      }
    });
  }

  getPaymentStatus(status?: SubscriptionStatus): string {
    if (!status) {
      return 'No Subscription';
    }

    switch (status) {
      case SubscriptionStatus.TRIALING:
        return 'Trial Period';
      case SubscriptionStatus.ACTIVE:
        return 'Paid';
      case SubscriptionStatus.PAST_DUE:
        return 'Payment Overdue';
      case SubscriptionStatus.UNPAID:
        return 'Payment Failed';
      case SubscriptionStatus.INCOMPLETE:
        return 'Pending Activation';
      case SubscriptionStatus.INCOMPLETE_EXPIRED:
        return 'Activation Failed';
      case SubscriptionStatus.CANCELED:
        return 'Canceled';
      case SubscriptionStatus.PAUSED:
        return 'Paused';
      default:
        return 'Unknown';
    }
  }

  downloadAgentsCSV(agents: SalesAgentUsersGet[]) {
    const rows: string[] = [];

    // CSV Header
    rows.push('Agent ID,Agent Name,User First Name,User Last Name,User Role,User Joined,Company Name,Subscription Status,Payment Status');

    for (const agent of agents) {
      if (agent.referred_users?.length) {
        for (const user of agent.referred_users) {
          rows.push([
            `"${agent.id}"`,
            `"${agent.name}"`,
            `"${user.first_name}"`,
            `"${user.last_name}"`,
            `"${user.role}"`,
            `"${user.joined}"`,
            `"${user.company?.name || ''}"`,
            `"${user.membership?.membership_type || ''}"`,
            `"${this.getPaymentStatus(user.membership?.customer?.latest_subscription?.status) || ''}"`
          ].join(','));
        }
      } else {
        rows.push([
          `"${agent.id}"`,
          `"${agent.name}"`,
          '', '', '', '', ''
        ].join(','));
      }
    }

    const csvContent = rows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `sales_agents_${new Date().toISOString()}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
